<template>

<svg :width="sizing" :height="sizing" class="fill-current" viewBox="0 0 12 16" version="1.1" aria-hidden="true"><path fill-rule="evenodd" d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48L7.48 8z"></path></svg>

</template>

<script>
export default {
    props: {
        size: { type: String, default: "sm", require: false}
    },

    computed: {
        sizing: function(){
            if(this.size == "sm"){
                return 16
            }

            if(this.size == "md"){
                return 24
            }

            if(this.size == "lg"){
                return 32
            }

            return 16
        }
    }
}
</script>

<style>

</style>